"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _MaskedInput = require("./MaskedInput");
Object.keys(_MaskedInput).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _MaskedInput[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _MaskedInput[key];
    }
  });
});